import { ACTIONS, MUTATIONS } from "./names";
import { Provider } from "~/core/types/affility/web3/Provider";

export default {
    [ACTIONS.SET_PROVIDER]({ commit }, provider: Provider) {
        commit(MUTATIONS.SET_PROVIDER, provider);
    },
};